<form onsubmit="return false;" [formGroup]="UserForm" (ngSubmit)="signInNew(username.value, password.value)">
  <div class="container box">
      <label id="uname">
          <b>Email</b></label>
      <input 
        type="text" placeholder="Enter Email"
        name="uname" 
        formControlName="email"
        [(ngModel)]="user.email" 
        #username
        required 
      />
      
      <label id="psw"><b>Password</b></label>
      <input 
        type="password"
        placeholder="Enter Password"
        name="psw"
        formControlName="pass"
        [(ngModel)]="user.pass"
        #password
        required
      />

      <p>{{msg}}</p>

      <button type="submit">Login</button>
      <button type="submit" routerLink="/signup">Create new Account</button>

    </div>

    <div class="container" style="background-color: #f1f1f1">
      <button type="button" routerLink="/" class="cancelbtn">Cancel</button>
        <span class="psw">Forgot <a routerLink="/forget-password">password?</a>
        </span>

    </div>
</form>

